import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const header = css`
  display: flex;
  margin: 0 0 ${spacing.lg}px 0;
  padding-bottom: ${spacing.sm}px;
  margin-top: ${pxToRem(10)};
  justify-content: center;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 0 ${spacing.xl}px 0;
      padding-bottom: ${spacing.md}px;
    `,
  )}
`;

export const carousel = css`
  overflow: hidden;
  margin-bottom: ${pxToRem(14)};
  margin-top: ${pxToRem(-6)};

  ${mediaQuery(
    { min: minBreakpoints.M, max: maxBreakpoints.M },
    css`
      margin-bottom: ${spacing.md}px;
    `,
  )}
`;
